import API from "../../../app/api";

export const gettopoffer = async () => {
  try {
    const res = await API.get("/banners");

    if (res.data?.success) {
      // Return only Top Offers banners
      return res.data.data["top-offers"]?.banners || [];
    }

    return [];
  } catch (error) {
    console.error("Top Offer Error:", error);
    return [];
  }
};